// extracted by mini-css-extract-plugin
export default {"tableWrapper":"style_tableWrapper__0+VWe","table":"style_table__tXX5y","svg":"style_svg__Jma5Z","content":"style_content__XfD1M","highlight":"style_highlight__lsf0K"};